if (
  typeof Number !== undefined
  && Number.prototype
  && !Number.prototype.toFixedNumber
) {
  Object.defineProperty(Number.prototype, 'toFixedNumber', {
    value(x, base = 10) {
      const pow = Math.pow(base, x);
      return + (Math.round(this * pow) / pow);
    }
  });
}